import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Helmet>
        <title>Nisham Ghimire | Portfolio</title>
        <meta name="description" content="Learn more about Nisham Ghimire - his interests, hobbies, and expertise." />
        {/* Add any other necessary meta tags for SEO optimization */}
      </Helmet>
      <Container>
        <Row>
          <Col md={8} className="home-about-description">            <h1 style={{ fontSize: "2.6em" }}>
            ABOUT <span className="purple">ME</span>
          </h1>
            <p className="home-about-body">
              Hey! I'm Nisham Ghimire, a graduate from Kathmandu University.
              <br />
              <br />
              I'm not your typical coder. I'm more like a strategic analyst who leverages technology to solve complex problems.
              <br />
              <br />
              My daily focus areas:
              <br />
              <br />
              <i>
                <b className="purple">• Dissecting business models and market psychology</b>
              </i>
              <br />
              <br />
              <i>
                <b className="purple">• Data science & AI research</b> - turning data into strategic insights
              </i>
              <br />
              <br />
              <i>
                <b className="purple">• Cybersecurity exploration</b> - understanding digital risk landscapes
              </i>
              <br />
              <br />
              <i>
                <b className="purple">• Building intelligent systems</b> that solve real business problems
              </i>
              <br />
              <br />
              <i>
                <b className="purple">• Strategic content creation</b> that influences decision-making
              </i>
              <br />
              <br />
              I approach technology from a strategic perspective - always asking how it can create value, mitigate risks, and drive meaningful outcomes.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/nishamghimire5"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://facebook.com/nishamghimire5"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/nisham-ghimire-473957170/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/nishamghimire"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container >
  );
}

export default Home2;
